import { GetFixedAsset } from "../../../WorkSpace/Components/ApiServices/apiHandler";

export const fetchAllFixedAsset = (search = "") => {
    return dispatch => {
        dispatch({type:"FIXEDASSET_ACTION_START"})
        GetFixedAsset(search).then((result)=>{
            dispatch({
                type: "FIXEDASSET_FETCH_DATA",
                payload: result.data.fixedAssets || result.data.fixedAsset || []
            }) 
        }).catch((error)=>{
            dispatch({
                type: "FIXEDASSET_FETCH_DATA_FAILED",
                payload: error.response?.data?.error
            }) 
        });
    }
}
